module.exports = __webpack_public_path__ + "static/media/3028692271535694869.7e5629c9.svg";